"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AppPermissions;

(function (AppPermissions) {
  AppPermissions["EditDashboard"] = "CP-EditDashboard";
  AppPermissions["ViewPositions"] = "CP-ViewPositions";
  AppPermissions["AddNewPosition"] = "CP-AddNewPosition";
  AppPermissions["ClosePosition"] = "CP-ClosePosition";
  AppPermissions["ExportPositions"] = "CP-ExportPositions";
  AppPermissions["EditPositions"] = "CP-EditPositions";
  AppPermissions["EditMyOwnPositions"] = "CP-EditMyOwnPositions";
  AppPermissions["ViewPosition"] = "CP-ViewPosition";
  AppPermissions["ViewPositionLocation"] = "CP-ViewPositionLocation";
  AppPermissions["EditPositionLocation"] = "CP-EditPositionLocation";
  AppPermissions["ViewPositionSchedule"] = "CP-ViewPositionSchedule";
  AppPermissions["EditPositionSchedule"] = "CP-EditPositionSchedule";
  AppPermissions["ViewPositionBilling"] = "CP-ViewPositionBilling";
  AppPermissions["EditPositionBilling"] = "CP-EditPositionBilling";
  AppPermissions["ViewPositionNotes"] = "CP-ViewPositionNotes";
  AppPermissions["EditPositionNotes"] = "CP-EditPositionNotes";
  AppPermissions["ViewShifts"] = "CP-ViewShifts";
  AppPermissions["ViewShift"] = "CP-ViewShift";
  AppPermissions["AddNewShift"] = "CP-AddNewShift";
  AppPermissions["ExportShifts"] = "CP-ExportShifts";
  AppPermissions["CancelShift"] = "CP-CancelShift";
  AppPermissions["ViewMatches"] = "CP-ViewMatches";
  AppPermissions["ExportMatches"] = "CP-ExportMatches";
  AppPermissions["ViewMatch"] = "CP-ViewMatch";
  AppPermissions["ViewAttachments"] = "CP-ViewAttachments";
  AppPermissions["ViewMatchCandidateDetails"] = "CP-ViewMatchCandidateDetails";
  AppPermissions["ViewMatchCredentials"] = "CP-ViewMatchCredentials";
  AppPermissions["PreviewAndDownloadMatchCredentials"] = "CP-PreviewAndDownloadMatchCredentials";
  AppPermissions["ViewMatchCredentialsBeforeFullPlacement"] = "CP-ViewMatchCredentialsBeforeFullPlacement";
  AppPermissions["ViewMatchNotes"] = "CP-ViewMatchNotes";
  AppPermissions["EditMatchNotes"] = "CP-EditMatchNotes";
  AppPermissions["MatchActionMakeOffer"] = "CP-MatchActionMakeOffer";
  AppPermissions["MatchActionRequestInterview"] = "CP-MatchActionRequestInterview";
  AppPermissions["MatchActionRejectMatch"] = "CP-MatchActionRejectMatch";
  AppPermissions["DataPreferences"] = "CP-DataPreferences";
  AppPermissions["NotificationSettings"] = "CP-NotificationSettings";
  AppPermissions["Reports"] = "CP-Reports";
  AppPermissions["ViewShiftBonus"] = "CP-ViewShiftBonus";
  AppPermissions["ViewPositionAdditionalInfo"] = "CP-ViewPositionAdditionalInfo";
  AppPermissions["EditPositionAdditionalInfo"] = "CP-EditPositionAdditionalInfo";
  AppPermissions["ViewMatchAdditionalInfo"] = "CP-ViewMatchAdditionalInfo";
  AppPermissions["EditMatchAdditionalInfo"] = "CP-EditMatchAdditionalInfo";
  AppPermissions["ReportProblem"] = "CP-ReportProblem";
  AppPermissions["Timesheets"] = "CP-Timesheets";
})(AppPermissions = exports.AppPermissions || (exports.AppPermissions = {}));